<template>
    <div class="p-4">
        <message-photo-upload v-if="type === 'messagePhoto'" :apiUrl="apiUrl" />
    </div>
</template>

<script>
import MessagePhotoUpload from '@/components/public/signed/MessagePhotoUpload';

export default {
    computed: {
        type() {
            return this.$route.query.type;
        },
        apiUrl() {
            return window.atob(this.$route.query.apiUrl);
        },
    },
    components: {
        MessagePhotoUpload,
    },
};
</script>
